import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-[#fdfbf7]" data-id="element-236">
      <div className="container mx-auto px-4" data-id="element-237">
        <div className="text-center mb-16" data-id="element-238">
          <h2 className="md:text-5xl font-extrabold text-[#1a3622] mb-4 text-[28px]" data-id="element-239">
            📦 ELEGÍ TU PACK
          </h2>
          <p className="text-[#5c4033] text-[16px]" data-id="element-240">
            Dos opciones — Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-241">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-2xl border border-[#e2e8f0] flex flex-col h-full relative z-10" data-id="element-242">
            <div className="mb-6" data-id="element-243">
              <p className="text-[#8b5a2b] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-244">
                🏆 OFERTA PRINCIPAL
              </p>
              <h3 className="font-bold text-[#1a3622] mb-2 flex items-center gap-2 text-[20px]" data-id="element-245">
                MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360
              </h3>
              <p className="text-[#5c4033] text-sm" data-id="element-246">
                Los 4 tomos principales + 12 libros especializados + bono de 4
                cuadernos de actividades — todo listo para usar.
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-[#e2e8f0]" data-id="element-247"></div>

            <div className="mb-8" data-id="element-248">
              <div className="flex items-end gap-2" data-id="element-249">
                <span className="text-5xl font-black text-[#1a3622]" data-id="element-250">
                  $19.990
                </span>
                <span className="text-xl font-bold text-[#5c4033] mb-1" data-id="element-251">
                  ARS
                </span>
              </div>
              <p className="text-[#8b5a2b] line-through mt-1" data-id="element-252">
                Precio real: $109.990 ARS
              </p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-253">
              <li className="flex items-start gap-2" data-id="element-254">
                <span className="text-[#1a3622]" data-id="element-255">✅ Pago seguro</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-256">
                <span className="text-[#1a3622]" data-id="element-257">✅ Acceso inmediato</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-258">
                <span className="text-[#1a3622]" data-id="element-259">✅ Garantía 7 días</span>
              </li>
            </ul>

            <a href="https://www.centralpack.shop/cart/53830980960574:1" target="_blank" rel="noopener noreferrer" className="block mt-auto" data-id="element-260">
              <Button variant="primary" size="lg" fullWidth data-id="element-261">
                🟢 QUIERO EL MEGAPACK — $19.990
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-[#1a3622] rounded-3xl p-8 shadow-2xl border-2 border-[#d4af37] flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-262">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#d4af37] text-[#1a3622] font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-263">
              <Zap className="w-4 h-4 fill-[#1a3622]" data-id="element-264" /> 🌟 MÁS ELEGIDO — MEJOR
              VALOR
            </div>

            <div className="mb-6 mt-2" data-id="element-265">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-266">
                MEGAPACK EDUCACIÓN AGROPECUARIA Y GANADERA 360 + VIVERO Y
                PROPAGACIÓN VEGETAL 360
              </h3>
              <p className="text-[#cbd5e1] text-sm" data-id="element-267">
                Llevás el pack agropecuario completo más el sistema de
                producción vegetal — para dominar tanto la producción animal
                como la vegetal desde un solo lugar.
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-[#2c4c3b]" data-id="element-268"></div>

            <div className="mb-8" data-id="element-269">
              <div className="flex items-end gap-2" data-id="element-270">
                <span className="text-5xl font-black text-white" data-id="element-271">$27.990</span>
                <span className="text-xl font-bold text-[#d4af37] mb-1" data-id="element-272">
                  ARS
                </span>
              </div>
              <p className="text-[#cbd5e1] line-through mt-1" data-id="element-273">
                Precio real: $149.990 ARS
              </p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-274">
              <li className="flex items-start gap-2" data-id="element-275">
                <span className="text-white" data-id="element-276">
                  ✔ Fundamentos de viveros y propagación vegetal
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-277">
                <span className="text-white" data-id="element-278">
                  ✔ Técnicas de reproducción sexual y asexual de plantas
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-279">
                <span className="text-white" data-id="element-280">
                  ✔ Manejo de sustratos, riego y nutrición en vivero
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-281">
                <span className="text-white" data-id="element-282">
                  ✔ Producción de plantines para el campo y la huerta
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-283">
                <span className="text-[#d4af37] font-bold" data-id="element-284">
                  ✔ El sistema completo para quien quiere dominar todo el ciclo
                  productivo
                </span>
              </li>
            </ul>

            <a href="https://www.centralpack.shop/cart/53830981026110:1" target="_blank" rel="noopener noreferrer" className="block mt-auto" data-id="element-285">
              <Button variant="primary" size="lg" fullWidth data-id="element-286">
                🟢 LLEVAR EL PACK COMPLETO — $27.990
              </Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}